import axios from 'axios/index';
import React, {PureComponent} from 'react';

import { Classes, Overlay } from "@blueprintjs/core";
import toastr from 'toastr';
import { getCurrentUserId, getJwt } from '../../services/authService';
import http from '../../services/httpService';

export default class VatCheckFailedModal extends PureComponent{
    state={
        overlayIsOpen: false,
        viberEnableRequests: '',
        loaderActive: false
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount(){
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }
    componentDidUpdate(){
        if (this.state.overlayIsOpen !== this.props.showModal){
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }
    render(){
        return(
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER} isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={ () =>{this.props.handleClose()} }><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel">
                        <h1 className="m-m-b">Invalid VAT Number</h1>
                        <div className="separator"></div>
                        <div className="form-group m-m-b" style={{marginTop: 20}}>

                            <span>This is not a valid VAT number, please check your input or proceed anyway(VAT number will not be saved).</span>
                        </div>
                        <div className="separator m-m-b"></div>
                        <div style={{display: 'flex', alignItems: 'space-between'}}>
                            <button
                                disabled={ false }
                                onClick={ () =>{
                                    this.props.handleClose()
                                } }
                                name="cancel_delete_tag"
                                id="cancel_delete_tag"
                                type="button"
                                className='btn-action btn-sm m-sm-b center'
                            >
                                Change VAT Number
                            </button>

                            <button
                                disabled={ false }
                                onClick={ () =>{
                                    this.props.handleContinueAnyWay()
                                    this.props.handleClose()
                                } }
                                type="button"
                                className='btn-action btn-sm m-sm-b center'
                            >
                                Proceed Anyway
                            </button>

                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}